const state = {
  hotList: [],
  board: {},
  boardList: [],
  boardCnt: 0,
  boardReplyListMine: [],
  boardReplyList: [],
  knowhow: {},
  knowhowList: [],
  knowhowCnt: 0,
  knowhowAnswerList: [],
  knowhowAnswerDetail: [],
  knowhowReplyList: [],
  knowhowReplyListMine: [],
  hotPostList: [],
};

export default state;
